module.exports = __webpack_public_path__ + "img/Rectangle 23.d6f8a376.png";